export default __webpack_public_path__ + "static/Swiss721BT-Light-8c4c05dea5c999946c589d84aa76a376.ttf";